import { SET_HIDE_NAVBAR} from "./hideNavbarActions";

const INITIAL_STATE = {
  navbar: true,

};

const setHideNavbarReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case  SET_HIDE_NAVBAR:
      return {
        ...state,
        navbar: !state.navbar,
      };



    default:
      return state;
  }
};

export default setHideNavbarReducer;
